import { render, staticRenderFns } from "./NxTable.vue?vue&type=template&id=2c53a6b2&scoped=true&"
import script from "./NxTable.vue?vue&type=script&lang=js&"
export * from "./NxTable.vue?vue&type=script&lang=js&"
import style0 from "./NxTable.vue?vue&type=style&index=0&id=2c53a6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53a6b2",
  null
  
)

export default component.exports